import React from "react"
import TextBlock from "../index"

const Primary = ({ children, padding }) => {
  return <TextBlock theme="primary" children={children} padding={padding} />
}

export default Primary
